import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.locationKey !== this.props.locationKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center p-8">
          <h1 className="text-2xl font-bold text-slate-900 mb-4">Une erreur est survenue</h1>
          <p className="text-slate-600 mb-6">Cette page n'a pas pu s'afficher correctement.</p>
          <a href="/" className="px-6 py-3 rounded-full bg-blue-600 text-white font-medium">
            Retour à l'accueil
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
